export default __webpack_public_path__ + "static/media/MROOM_Q3-25_ETU.76656864.jpg";